import * as EmailValidator from "email-validator"

export const verifyEmail = EmailValidator.validate
